import { setAppCode, setPlatformCode } from '@micun/web-components'

setAppCode('portal')
setPlatformCode('web')
